import { render } from "./Situation.vue?vue&type=template&id=0d8beb38&scoped=true"
import script from "./Situation.vue?vue&type=script&lang=js"
export * from "./Situation.vue?vue&type=script&lang=js"

import "./Situation.vue?vue&type=style&index=0&id=0d8beb38&lang=scss&scoped=true"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d8beb38"]])

export default __exports__